import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string;
  categorySlug: string;
  rating: number;
  status: string;
  description: string;
}

export default function ComicCard({ id, title, author, cover, category, categorySlug, rating, status, description }: ComicCardProps) {
  return (
    <div className="group" data-product-shop>
      <Link to={`/comic/${id}`} className="block">
        <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
          <img
            src={cover}
            alt={title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-4">
            <p className="text-white text-xs leading-relaxed line-clamp-3">{description}</p>
          </div>
          <div className="absolute top-2 left-2">
            <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
              status === '连载中'
                ? 'bg-accent-500 text-white'
                : 'bg-foreground-700 text-white'
            }`}>
              {status}
            </span>
          </div>
          <div className="absolute top-2 right-2 bg-background-50/90 rounded-full px-2 py-0.5 text-xs font-semibold text-accent-600 whitespace-nowrap flex items-center gap-1">
            <i className="ri-star-fill text-[10px]"></i>
            {rating}
          </div>
        </div>
        <h3 className="text-sm font-semibold text-foreground-950 truncate group-hover:text-primary-500 transition-colors">
          {title}
        </h3>
        <div className="flex items-center gap-2 mt-1">
          <Link
            to={`/category/${categorySlug}`}
            onClick={(e) => e.stopPropagation()}
            className="text-xs text-secondary-600 hover:text-secondary-700 whitespace-nowrap"
          >
            {category}
          </Link>
          <span className="text-foreground-300 text-xs">·</span>
          <span className="text-xs text-foreground-500 truncate">{author}</span>
        </div>
      </Link>
    </div>
  );
}